var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-button"},[_c('router-link',{staticClass:"button is-primary is-inverted is-outlined is-rounded",attrs:{"to":("/leagues/signup/" + (_vm.season.id)),"type":"button"}},[_vm._v("Signup")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }